import { z } from "zod";
import { horizonIssueTypeDtoSchema, horizonSeverityDtoSchema } from "./common.schema";
export const horizonIssueDtoSchema = z.object({
    type: horizonIssueTypeDtoSchema,
    severity: horizonSeverityDtoSchema,
    advice: z.string().nullable(),
    message: z.string(),
    farmLicenseKey: z.string(),
});
export const customerHorizonIssuesDtoSchema = z.object({
    customerNumber: z.string(),
    horizonIssues: z.array(horizonIssueDtoSchema),
});
//# sourceMappingURL=farm-horizon-issues.schema.js.map